var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAkarIconsTabletDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83377 23.5006L7.83377 70.5007C7.83377 74.8269 11.3409 78.334 15.6671 78.334H78.3338C82.66 78.334 86.1671 74.8269 86.1671 70.5007V23.5006C86.1671 19.1744 82.66 15.6673 78.3338 15.6673L15.6671 15.6673C11.3409 15.6673 7.83377 19.1744 7.83377 23.5006Z",
    className: "svgStroke",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4998 50.918V43.0846",
    className: "svgStroke",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsTabletDevice);
export default __webpack_public_path__ + "static/media/akar-icons_tablet-device.7a9bef095192aa872349c76872cd7e59.svg";
export { ForwardRef as ReactComponent };